<template>

  <b-form class="mt-3" >
    <b-row v-if="props.mode == 'List'">

      <b-col
        cols="12"
        md="6"
      >
        <InputFilter :filter="search[0]" />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <InputFilter :filter="search[1]" />
      </b-col>

    </b-row>


    <!-- Action Buttons -->
    <div class="text-center pt-1">
      <b-button
        variant="primary"
        class="mb-1 mb-sm-0 mr-0 mr-sm-1"
        @click="onSearchBtnClicked"
      >
        เพิ่มผู้ใช้งาน
      </b-button>
      <b-button
        variant="outline-secondary"
        type="reset"
        @click="onResetBtnClicked"
      >
        ล้าง
      </b-button>
    </div>
  </b-form>

</template>

<script>
import {
  BButton, BAvatar, BRow, BCol, BFormGroup, BFormInput, BForm, BFormCheckbox,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import InputFilter from '../../../filters/components/InputFilter.vue'

export default {
  components: {
    BButton,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BFormCheckbox,
    vSelect,
    InputFilter,
  },
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  setup(props) {

    const options = [
      { text: 'ทั้งหมด', value: null },
      { text: 'ใช้งาน', value: true },
      { text: 'ไม่ใช้งาน', value: false },
    ]

    const searchList = [
      {
        id: 'text', label: 'คำค้นหา', value: '', class: '', style: '', placeholder: 'คำค้นหา', type: 'text', options: [],
      },
      {
        id: 'searchBy', label: 'หน่วยงาน', value: '', class: '', style: '', placeholder: 'หน่วยงาน', type: 'text', options: [],
      },
    ]


    return {
      options,
      search: searchList,
      props,
    }
  },
  methods: {
    onResetBtnClicked(){
       this.search[0].value=null
       this.search[1].value=null
       this.search[2].value=null
       this.search[3].value=null
       this.search[4].value=null
       this.search[5].value=null
    },
    onSearchBtnClicked() {
      const params = {
          keyword : this.search[0].value,
          searchBy : this.search[1].value,
      }
      
      //console.log('onSearchBtnClicked', params)

      this.$emit('handleSubmit', params)
    }
  }
}
</script>
 <style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>
